import { render } from "./BoilerPlate.vue?vue&type=template&id=70f3f972&scoped=true"
import script from "./BoilerPlate.vue?vue&type=script&lang=js"
export * from "./BoilerPlate.vue?vue&type=script&lang=js"

import "./BoilerPlate.vue?vue&type=style&index=0&id=70f3f972&lang=scss&scoped=true"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/AI_Playground/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f3f972"]])

export default __exports__